<div tabindex="-1" class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 flex-fill">
        <div class="d-flex align-items-center gap-2">
          <h6 class="modal-title" i18n>Custom Codes</h6>
          <app-page-help articleId="qUmR29rNg8YV6t7KegbC5g"></app-page-help>
        </div>
        <div class="flex-fill"></div>
        <button
          (click)="onDelete()"
          [disabled]="selection?.selected?.length === 0"
          i18n-matTooltip
          matTooltip="Delete selected Custom Codes."
          matTooltipPosition="below"
          type="button"
          class="btn btn-secondary-danger"
        >
          <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>Delete</ng-container>
        </button>
        <button
          type="button"
          class="btn btn-secondary-info"
          (click)="onCreate()"
          [matTooltip]="
            'Click here to create a new custom data dictionary code. Multiple custom codes can have the same name, as long as they are not assigned to the same rental.'
          "
          matTooltipPosition="above"
        >
          <span class="far fa-plus"></span>
          <ng-container i18n>New</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close" aria-label="Close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <div class="container-box p-3">
        <div class="filters-box border-bottom-0 px-0">
          <app-rental-select
            i18n-matTooltip
            i18n-placeholder
            matTooltip="Only show Custom Codes for specified rentals."
            matTooltipPosition="above"
            [items]="rentalOptions"
            [ctrl]="filters.get('rentals')"
            [inline]="true"
            placeholder="Rentals"
          ></app-rental-select>
          <app-entity-filter-tags
            i18n-matTooltip
            i18n-placeholder
            matTooltip="Only show Custom Codes by selected tags."
            matTooltipPosition="above"
            [tags]="tagOptions"
            [ctrl]="filters.get('tags')"
            [entityIdsCtrl]="filters.get('taggedIds')"
            type="custom_code"
            placeholder="Tags"
          ></app-entity-filter-tags>
          <app-cancel-filters
            [isFiltering]="filters | isFiltering"
            [filterControl]="filters"
            [searchCom]="searchCom"
          ></app-cancel-filters>
          <div class="flex-fill"></div>

          <app-table-search (search)="onSearch($event)" [filterGroup]="filterGroup" #searchCom></app-table-search>
        </div>
        <div class="table-holder table-responsive">
          <table class="table table-default table-striped">
            <mat-table #table matSort (matSortChange)="onSort($event)" [dataSource]="dataSource">
              <ng-container matColumnDef="select">
                <mat-header-cell *matHeaderCellDef>
                  <mat-checkbox
                    (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                  >
                  </mat-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                  <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)"
                  >
                  </mat-checkbox>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                  <ng-container i18n>Name</ng-container></mat-header-cell
                >
                <mat-cell *matCellDef="let element">
                  <span [matTooltip]="element.name" matTooltipPosition="above">
                    {{ element.name | truncate : 25 }}
                  </span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="description">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                  ><ng-container i18n>Description</ng-container></mat-header-cell
                >
                <mat-cell *matCellDef="let element">
                  <span [matTooltip]="element.description" matTooltipPosition="above">
                    {{ element.description | truncate : 25 }}
                  </span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="body">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                  <ng-container i18n>Value</ng-container></mat-header-cell
                >
                <mat-cell *matCellDef="let element">
                  <span [matTooltip]="element.body | stripHtml | truncate : 100" matTooltipPosition="above">
                    <span [innerHTML]="element.body | stripHtml | truncate : 25"></span>
                  </span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="creatorView">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                  <ng-container i18n>Creator</ng-container></mat-header-cell
                >
                <mat-cell *matCellDef="let element">
                  {{ element.creatorView }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="created">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                  <ng-container i18n>Created</ng-container></mat-header-cell
                >
                <mat-cell *matCellDef="let element">
                  <span [matTooltip]="element.created | epoch" matTooltipPosition="above">
                    {{ element.createdView }}
                  </span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="rentalNames">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                  <ng-container i18n>Rental</ng-container></mat-header-cell
                >
                <mat-cell *matCellDef="let element">
                  <span [matTooltip]="element.rentalNames" matTooltipPosition="above">
                    {{ element.rentalNames | truncate : 25 }}
                  </span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="tagView">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                  <ng-container i18n>Tags</ng-container></mat-header-cell
                >
                <mat-cell *matCellDef="let element">
                  <span [matTooltip]="element.tagView" matTooltipPosition="above">
                    {{ element.tagView | truncate : 25 }}
                  </span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="edit">
                <mat-header-cell *matHeaderCellDef>
                  <app-table-column-manager
                    tableId="custom-codes"
                    [displayedColumns]="displayedColumns"
                    (columnsChanged)="displayedColumns = $event"
                  ></app-table-column-manager>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <div dropdown placement="bottom right" container="body">
                    <div dropdownToggle (click)="$event.stopPropagation()" class="btn-group btn-ellips-holder">
                      <a class="btn-ellips">
                        <i class="fas fa-ellipsis-v"></i>
                      </a>
                    </div>
                    <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
                      <li>
                        <button type="button" (click)="onEdit(element)">
                          <i class="fal fa-edit"></i><ng-container i18n>Edit</ng-container>
                        </button>
                      </li>
                      <li>
                        <button type="button" (click)="onDelete(element)">
                          <i class="cs-icon cs-icon-trash"></i><ng-container i18n>Delete</ng-container>
                        </button>
                      </li>
                    </ul>
                  </div>
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row
                *matRowDef="let row; columns: displayedColumns"
                (click)="onEdit(row)"
                class="clickable"
              ></mat-row>
            </mat-table>

            <mat-paginator2
              #paginator
              [length]="dataSource?.data?.length"
              [class.hidden]="isEmptyTable$ | async"
              [pageSize]="10"
              [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
              [showFirstLastButtons]="true"
            >
            </mat-paginator2>
          </table>
          <app-empty-table *ngIf="isEmptyTable$ | async" [type]="tableType"></app-empty-table>
        </div>
      </div>
    </div>
  </div>
</div>
